import { MissionItemComponent } from './mission-item.component';

export default angular
  .module('sfMobile.components.mission-item', [
    'pascalprecht.translate',
    'sfMobile.constants.image-sizes',
    'sfMobile.services.files',
  ])
  .component('sfMissionItem', MissionItemComponent).name;
